<template>
  <div style="background-color: white">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row class="m-0">
      <b-col cols="12">
        <b-col class="mb-2 text-left">
          <span style="color: #0d86d7; font-weight: 600; font-size: 12px">Historial de cambios del PTI después de aceptación</span>
        </b-col>

        <b-col md="12">
          <b-row class="contenedorTablaSinColor m-0" style="background:white ">
            <b-col>
              <b-input-group>
                <b-form-input
                    class="input-filter"
                    type="search"
                    id="filterInput"
                    responsive
                    placeholder="Búsqueda de tratamientos"
                    @keydown.enter.native="version5 ? buscarTratamientosV5() : buscarTratamientos()"
                    v-model="filtro.tratamiento"
                >
                </b-form-input>
                <b-input-group-append>
                  <b-dropdown
                      class="input-filter"
                      @hide="search.etapaSearch = ''"
                      variant="white"
                      responsive
                  >
                    <template #button-content>
                  <span :class="filtroSeleccionado.length > 0 ? 'filtro' : 'filtro-normal'" style="font-size: .75em;">
                    {{ filtroSeleccionado.length > 0 ? '(' + filtroSeleccionado.length + ') Filtros' : 'Estatus' }}
                  </span>
                    </template>


                    <div class="contenedor-drop">
                      <b-form-group class="m-1" v-slot="{ ariaDescribedby }">
                        <b-form-radio
                            v-for="option in opcionesEstatusV5"
                            v-model="filtro.estatus"
                            :key="option.idEstatusPtiTratamiento"
                            :value="option.idEstatusPtiTratamiento"
                            :aria-describedby="ariaDescribedby"
                            name="flavour-3a"
                        >
                          {{ option.descripcion }}
                        </b-form-radio>
                      </b-form-group>
                      <b-button size="sm" variant="light" @click="filtro.estatus = 0"><b-icon icon="x"></b-icon> Eliminar filtro</b-button>
                    </div>
                  </b-dropdown>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2">
              <b-button
                  class="mt-1"
                  size="sm"
                  variant="info"
                  :disabled="loading"
                  @click="version5 ? buscarTratamientosV5() : buscarTratamientos"
                  responsive
              >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm" style="position: relative; top: 1px;"></em>
              </span>
                <span v-else><b-spinner small></b-spinner></span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <div v-if="!version5">
        <div class="scrollBarra">
          <div v-if="listaHistorial.length >0 ">
          <div v-for="(historial) in listaHistorial" :key="historial.idHistorial">
            <div class="mt-2" v-if="historial.observaciones == null">
              <b-row cols="12" class="ml-2 mr-2">
                <b-col class="contenedorTablaSinColor mt-3" sm="12" md="12" lg="12">
                  <logo-usuario :usrName="historial.usuarioModifico" :fechaModificacion="historial.fechaModificacion"/>
                  <p class="text-left ml-2" style="font-size: 0.70em;"><strong>Cambio en pti actual</strong></p>
                  <div v-for="(cambio, index) in historial.cambios" :key="index">
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;"> El
                      tratamiento
                      “{{ cambio.nombreTx }}” del OD {{ cambio.od }} se ha {{ cambio.accion }}.</p>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mt-2" v-else>
              <b-row cols="12" class="ml-2 mr-2">
                <b-col class="contenedorTablaSinColor mt-3" sm="12" md="12" lg="12">
                  <logo-usuario :usrName="historial.usuarioModifico" :fechaModificacion="historial.fechaModificacion"/>
                  <p class="text-left ml-2" style="font-size: 0.70em;"><strong>Nuevos movimientos</strong></p>
                  <div v-for="(cambio, index) in historial.cambios" :key="index">
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;"> 
                      Doctores que solicitaron: {{ cambio.doctor }}
                    </p>
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;">
                      Observaciones: {{ historial.observaciones }}
                    </p>
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;" v-if="cambio.nombreTxAnterior == null"> 
                      El nuevo tratamiento fuera del PTI "{{ cambio.nombreTxActual }}" se ha agregado
                    </p>
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;" v-if="cambio.nombreTxAnterior != null">
                      El tratamiento "{{ cambio.nombreTxAnterior }}" se ha cambiado por "{{ cambio.nombreTxActual }}"
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div style="margin-top: 30vh !important; color: #17a2b8; font-weight: bold;" v-else>
          <p>No se encontraron cambios en el pti</p>
        </div>
        </div>
        </div>
        <div v-else>
          <div v-if="listaHistorial.length > 0">
            <div v-for="(historial, index) in listaHistorial" :key="'historia-'+index">
              <div class="mt-2" v-if="historial.historial !== null && historial.historial.length > 0">
                <b-row cols="12" class="ml-2 mr-2">
                  <b-col class="contenedorTablaSinColor mt-3" sm="12" md="12" lg="12">
                    <logo-usuario :usrName="historial.historial[0].usuarioModifico" :fechaModificacion="historial.historial[0].fechaModificacion"/>

                    <p class="formato-letras ml-2 text-left bold" style="font-size: 0.80em;">
                      Cambios en el PTI
                    </p>
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;">
                      Doctores que solicitaron: {{ historial.doctores.toString() }}
                    </p>
                    <p class="formato-letras ml-2 text-left" style="font-size: 0.80em;">
                      Observaciones:
                      <TextoVerMas
                          :texto-completo="historial.observaciones"
                          :max-length="15"/>
                    </p>

                    <p class="formato-letras ml-2 text-left bold" style="font-size: 0.80em; color: #59c43e"
                       v-if="historial.historial.filter(h => h.idAccion === 9 && h.tratamientoAnterior === null).length > 0">
                      Se agregó un nuevo tratamiento
                    </p>
                    <div>
                      <ol class="formato-letras ml-2 text-left pl-3" style="font-size: 0.80em;">
                        <li style="list-style: auto !important;" v-for="(cambio, index) in historial.historial.filter(h => h.idAccion === 9 && h.tratamientoAnterior === null)" :key="'agregado-'+index">{{ cambio.nombreTx }} en el OD {{ cambio.diente }}</li>
                      </ol>
                    </div>

                    <p class="formato-letras ml-2 text-left bold" style="font-size: 0.80em; color: #63aeb9"
                       v-if="historial.historial.filter(h => h.idAccion === 9 && h.tratamientoAnterior !== null).length > 0">
                      Cambio de tratamiento
                    </p>
                    <div>
                      <ol class="formato-letras ml-2 text-left pl-3" style="font-size: 0.80em;">
                        <li v-for="(cambio, index) in historial.historial.filter(h => h.idAccion === 9 && h.tratamientoAnterior !== null)" :key="'cambio-'+index" style="list-style: auto !important;">
                          El tratamiento "{{ cambio.tratamientoAnterior }}" del OD {{ cambio.diente }} se ha cambiado por "{{ cambio.nombreTx }}"
                        </li>
                      </ol>
                    </div>

                    <p class="formato-letras ml-2 text-left bold" style="font-size: 0.80em; color: #cd5f5f"
                    v-if="historial.historial.filter(h => h.idAccion === 5).length > 0">
                      Eliminación de tratamiento
                    </p>
                    <div>
                      <ol class="formato-letras ml-2 text-left pl-3" style="font-size: 0.80em;">
                        <li v-for="(cambio, index) in historial.historial.filter(h => h.idAccion === 5)" :key="'eliminado-'+index" style="list-style: auto !important;">{{ cambio.nombreTx }} del OD {{ cambio.diente }}</li>
                      </ol>
                    </div>

                    <p class="formato-letras ml-2 text-left bold" style="font-size: 0.80em; color: #59c43e"
                    v-if="historial.historial.filter(h => h.idAccion === 7).length > 0">
                      Se presentó un tratamiento existente
                    </p>
                    <div>
                      <ol class="formato-letras ml-2 text-left pl-3" style="font-size: 0.80em;">
                        <li v-for="(cambio, index) in historial.historial.filter(h => h.idAccion === 7)" :key="'presento-'+index" style="list-style: auto !important;">{{ cambio.nombreTx }} del OD {{ cambio.diente }}</li>
                      </ol>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <div style="margin-top: 30vh !important; color: #17a2b8; font-weight: bold;" v-else>
            <p>No se encontraron cambios en el pti</p>
          </div>
        </div>
      </b-col>


    </b-row>
  </div>
</template>

<script>
import LogoUsuario from "@/views/historialPTI/logoUsuario.vue";
import TextoVerMas from "@/version5/componentes/TextoVerMas.vue";

export default {
  name: "historialCambios",
  components: {TextoVerMas, LogoUsuario},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      date: '',
      ultimaActualizacion: null,
      tratamientos: {
        fechaActual: ''
      },

      loading: false,
      loadingCambiosPti: false,

      currentPage: 1,
      items: [],
      registrosPorPagina: 10,

      search: {
        clinicaSearch: "",
        etapaSearch: "",
        clasificacionSearch: "",
      },

      filtro: {
        tratamiento: '',
        estatus: 0
      },
      filtroSeleccionado: 1,
      listaHistorial: []
    }
  },
  props: {
    idPti: Number,
    opcionesEstatus: Array,
    version5: Boolean
  },
  mounted() {
    if (!this.version5) {
      this.buscarTratamientos();
    } else {
      this.buscarTratamientosV5();
    }
  },
  computed: {
    opcionesEstatusV5() {
      return this.opcionesEstatus.filter(op => op.idEstatusPtiTratamiento === 9 ||
          op.idEstatusPtiTratamiento === 8 ||
          op.idEstatusPtiTratamiento === 5 ||
          op.idEstatusPtiTratamiento === 7);
    }
  },
  methods: {
    buscarTratamientos() {
      this.currentPage = 1;
      this.loading = true;
      this.listaHistorial = [];
      const params = {
        idPti: this.idPti,
        tratamiento: this.filtro.tratamiento,
        estatus: this.filtro.estatus
      }
      this.$http
          .post(this.$api + "pti/visible/obtener/historial/ptiActual", params ).then((response) => {
            this.listaHistorial = response.data.data;
            this.listaHistorial = this.listaHistorial.reduce((lista, item) => {
              const existeFecha = lista.find(l => l.fechaModificacion === item.fechaModificacion);
              if (existeFecha) {
                if(item.observaciones != null){
                  existeFecha.cambios[0].doctor = this.listaHistorial[lista.length-1].doctor + ", " + item.doctor;
                }else{
                  existeFecha.cambios.push({accion: item.accion, nombreTx: item.nombreTx, od: item.od, dato: item.observaciones});
                }
              } else { 
                if(item.observaciones != null){
                  lista.push({usuarioModifico: item.usuarioModifico,
                    fechaModificacion: item.fechaModificacion, observaciones: item.observaciones,
                    cambios: [{accion: item.accion, nombreTx: item.nombreTx, od: item.od, 
                      nombreTxAnterior: item.tratamientoAnterior, nombreTxActual: item.tratamientoActual, 
                      doctor: item.doctor}]
                  });
                }else{
                  lista.push({usuarioModifico: item.usuarioModifico,
                    fechaModificacion: item.fechaModificacion,
                    cambios: [{accion: item.accion, nombreTx: item.nombreTx, od: item.od}]
                  });
                }
              }

              return lista;
            }, []);

          }).finally(() => {
        this.loading = false;
      });
    },
    buscarTratamientosV5() {
      this.currentPage = 1;
      this.loading = true;
      this.listaHistorial = [];
      const params = {
        idPti: this.idPti,
        tratamiento: this.filtro.tratamiento,
        estatus: this.filtro.estatus
      }
      this.$http
          .post(this.$api + "edicion/obtener/historial", params ).then((response) => {
            this.listaHistorial = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>
.formato-letras {
  text-align: left;
}

input::placeholder {
  font-size: .75em;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file {
  padding: 0px;
}
 .input-group > .input-group-append > .btn-group > .btn, .input-group > .input-group-prepend:not(:first-child) > .btn-group > .btn, .input-group > .input-group-prepend:first-child > .btn-group:not(:first-child) > .btn {
   padding: 0;
 }
.scrollBarra {
  height: 50vh;
}
</style>
